export default __webpack_public_path__ + "static/media/home1.fd5799e9.svg";